import React from 'react';

const Button = () => {
  return (
    <button type='button' className='bg-blue-gradient px-6 py-4 rounded-[10px] font-poppins font-medium text-[18px] text-primary uppercase'>
      Get Started
    </button>
  )
}

export default Button
